export default [
  {
    "login": "OnahProsperity",
    "id": 40717516,
    "node_id": "MDQ6VXNlcjQwNzE3NTE2",
    "avatar_url": "https://avatars.githubusercontent.com/u/40717516?v=4",
    "gravatar_id": "",
    "url": "https://api.github.com/users/OnahProsperity",
    "html_url": "https://github.com/OnahProsperity",
    "followers_url": "https://api.github.com/users/OnahProsperity/followers",
    "following_url": "https://api.github.com/users/OnahProsperity/following{/other_user}",
    "gists_url": "https://api.github.com/users/OnahProsperity/gists{/gist_id}",
    "starred_url": "https://api.github.com/users/OnahProsperity/starred{/owner}{/repo}",
    "subscriptions_url": "https://api.github.com/users/OnahProsperity/subscriptions",
    "organizations_url": "https://api.github.com/users/OnahProsperity/orgs",
    "repos_url": "https://api.github.com/users/OnahProsperity/repos",
    "events_url": "https://api.github.com/users/OnahProsperity/events{/privacy}",
    "received_events_url": "https://api.github.com/users/OnahProsperity/received_events",
    "type": "User",
    "site_admin": false
  },
  {
    "login": "Tolu-ybm",
    "id": 106484227,
    "node_id": "U_kgDOBljSAw",
    "avatar_url": "https://avatars.githubusercontent.com/u/106484227?v=4",
    "gravatar_id": "",
    "url": "https://api.github.com/users/Tolu-ybm",
    "html_url": "https://github.com/Tolu-ybm",
    "followers_url": "https://api.github.com/users/Tolu-ybm/followers",
    "following_url": "https://api.github.com/users/Tolu-ybm/following{/other_user}",
    "gists_url": "https://api.github.com/users/Tolu-ybm/gists{/gist_id}",
    "starred_url": "https://api.github.com/users/Tolu-ybm/starred{/owner}{/repo}",
    "subscriptions_url": "https://api.github.com/users/Tolu-ybm/subscriptions",
    "organizations_url": "https://api.github.com/users/Tolu-ybm/orgs",
    "repos_url": "https://api.github.com/users/Tolu-ybm/repos",
    "events_url": "https://api.github.com/users/Tolu-ybm/events{/privacy}",
    "received_events_url": "https://api.github.com/users/Tolu-ybm/received_events",
    "type": "User",
    "site_admin": false
  },
  {
    "login": "codinghemp",
    "id": 114475644,
    "node_id": "U_kgDOBtLCfA",
    "avatar_url": "https://avatars.githubusercontent.com/u/114475644?v=4",
    "gravatar_id": "",
    "url": "https://api.github.com/users/codinghemp",
    "html_url": "https://github.com/codinghemp",
    "followers_url": "https://api.github.com/users/codinghemp/followers",
    "following_url": "https://api.github.com/users/codinghemp/following{/other_user}",
    "gists_url": "https://api.github.com/users/codinghemp/gists{/gist_id}",
    "starred_url": "https://api.github.com/users/codinghemp/starred{/owner}{/repo}",
    "subscriptions_url": "https://api.github.com/users/codinghemp/subscriptions",
    "organizations_url": "https://api.github.com/users/codinghemp/orgs",
    "repos_url": "https://api.github.com/users/codinghemp/repos",
    "events_url": "https://api.github.com/users/codinghemp/events{/privacy}",
    "received_events_url": "https://api.github.com/users/codinghemp/received_events",
    "type": "User",
    "site_admin": false
  },
  {
    "login": "super124dev",
    "id": 124944121,
    "node_id": "U_kgDOB3J--Q",
    "avatar_url": "https://avatars.githubusercontent.com/u/124944121?v=4",
    "gravatar_id": "",
    "url": "https://api.github.com/users/super124dev",
    "html_url": "https://github.com/super124dev",
    "followers_url": "https://api.github.com/users/super124dev/followers",
    "following_url": "https://api.github.com/users/super124dev/following{/other_user}",
    "gists_url": "https://api.github.com/users/super124dev/gists{/gist_id}",
    "starred_url": "https://api.github.com/users/super124dev/starred{/owner}{/repo}",
    "subscriptions_url": "https://api.github.com/users/super124dev/subscriptions",
    "organizations_url": "https://api.github.com/users/super124dev/orgs",
    "repos_url": "https://api.github.com/users/super124dev/repos",
    "events_url": "https://api.github.com/users/super124dev/events{/privacy}",
    "received_events_url": "https://api.github.com/users/super124dev/received_events",
    "type": "User",
    "site_admin": false
  }
]
